export default function TelegramIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.2291 4.51494L4.21878 10.5666C3.29505 10.9656 3.47269 12.3254 4.46793 12.4737L7.6712 12.951C7.88466 12.9828 8.10268 12.9447 8.29269 12.8424L13.6111 9.97866C13.8039 9.87482 13.9994 10.1119 13.8607 10.2814L10.6064 14.2589C10.2673 14.6733 10.3148 15.2812 10.7142 15.6379L15.1474 19.5977C15.7211 20.1101 16.6345 19.8099 16.7923 19.057L19.6043 5.63806C19.7706 4.84464 18.9733 4.19349 18.2291 4.51494Z"
          stroke="white"
        />
      </svg>
    </>
  );
}
